import parecerCardiologicoServices from "@/api/parecerCardiologico/parecerCardiologicoServices";

export default {
  generate({ commit }, data) {
    return parecerCardiologicoServices
      .generate(data)
      .then((result) => result)
      .catch((error) => error);
  },
  salvarExameFisico({ commit }, data) {
    return parecerCardiologicoServices
      .salvarExameFisico(data)
      .then((result) => result)
      .catch((error) => error);
  },
  salvarSimtomatologia({ commit }, data) {
    return parecerCardiologicoServices
      .salvarSimtomatologia(data)
      .then((result) => result)
      .catch((error) => error);
  },
  salvarFatorDeRisco({ commit }, data) {
    return parecerCardiologicoServices
      .salvarFatorDeRisco(data)
      .then((result) => result)
      .catch((error) => error);
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) =>
      parecerCardiologicoServices
        .getById(id)
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => reject(err))
    );
  },
  getPatientById({ commit }, id) {
    return new Promise((resolve, reject) =>
      parecerCardiologicoServices
        .getPatientById(id)
        .then((result) => {
          resolve(result.data);
        })
        .catch((err) => reject(err))
    );
  },
  salvarRecomendacao({ commit }, data) {
    return parecerCardiologicoServices
      .salvarRecomendacao(data)
      .then((result) => result)
      .catch((error) => error);
  },
  salvarExamesComplementares({ commit }, data) {
    return parecerCardiologicoServices
      .salvarExamesComplementares(data)
      .then((result) => result)
      .catch((error) => error);
  },
  salvarConclusao({ commit }, data) {
    return parecerCardiologicoServices
      .salvarConclusao(data)
      .then((result) => result)
      .catch((error) => error);
  },
  salvarMedicamentoEmUso({ commit }, data) {
    return parecerCardiologicoServices
      .salvarMedicamentoEmUso(data)
      .then((result) => result)
      .catch((error) => error);
  },
};
